@if (item.separator) {
  <li class="menu-separator"></li>
} @else if (hasChildren) {
  <li class="menu-item menu-parent" [class.is-expanded]="isExpanded">
    <div
      class="menu-link"
      (click)="toggle($event)"
      pRipple
      [pTooltip]="isSlimCollapsed ? item.label : ''"
      tooltipPosition="right">
      @if (item.icon) {
        <i [class]="item.icon" class="menu-icon"></i>
      }
      @if (!isSlimCollapsed) {
        <span class="menu-text">{{ item.label }}</span>
        <i class="pi pi-angle-right menu-toggle-icon" [class.rotated]="isExpanded"></i>
      }
    </div>
    @if (isExpanded) {
      <ul class="sub-menu">
        @for (child of item.items; track child.label) {
          <app-menu-item [item]="child" [depth]="depth + 1" />
        }
      </ul>
    }
  </li>
} @else {
  <li class="menu-item">
    <a
      [routerLink]="item.routerLink"
      routerLinkActive="active"
      class="menu-link"
      pRipple
      [pTooltip]="isSlimCollapsed ? item.label : ''"
      tooltipPosition="right">
      @if (item.icon) {
        <i [class]="item.icon" class="menu-icon"></i>
      }
      @if (!isSlimCollapsed) {
        <span class="menu-text">{{ item.label }}</span>
        @if (item.badge) {
          <span class="menu-badge badge-{{ item.badgeSeverity ?? 'info' }}">{{ item.badge }}</span>
        }
      }
    </a>
  </li>
}
